import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { MessageSquare, Instagram, Facebook, Mail, Phone, Globe, MapPin } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import DeveloperProfileCard from "@/components/about/DeveloperProfileCard";
const AboutUs = () => {
  const openWhatsApp = () => {
    window.open("https://wa.me/93784604196", "_blank");
  };
  const openInstagram = () => {
    window.open("https://www.instagram.com/mr.shukraan/?utm_source=qr&r=nametag", "_blank");
  };
  const openFacebook = () => {
    window.open("https://facebook.com/mr.shukraan", "_blank");
  };
  const sendEmail = () => {
    window.open("mailto:www.mrdesigner.af@gmail.com", "_blank");
  };
  const callPhone = () => {
    window.open("tel:+93784604196", "_blank");
  };
  const openWebsite = () => {
    window.open("https://mrshukraan.netlify.app", "_blank");
  };
  const openLocation = () => {
    window.open("https://maps.google.com/?q=Kabul,Afghanistan,1005", "_blank");
  };
  const contactActions = {
    onWhatsApp: openWhatsApp,
    onInstagram: openInstagram,
    onFacebook: openFacebook,
    onEmail: sendEmail,
    onPhone: callPhone,
    onWebsite: openWebsite
  };
  return <div className="container py-8 max-w-5xl mx-auto">
      <div className="mb-12">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }}>
          <h1 className="text-3xl font-bold tracking-tight text-nalc-dark dark:text-white mb-4">
            About Us
          </h1>
          <p className="text-muted-foreground mb-8">
            Learn more about Noor Ali Learning Center and the team behind it.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} className="grid gap-8 md:grid-cols-2">
          {/* Company Information */}
          <Card className="bg-white dark:bg-slate-800 shadow-sm">
            <CardHeader>
              <div className="flex items-center gap-3">
                <motion.div initial={{
                x: -50,
                opacity: 0
              }} animate={{
                x: 0,
                opacity: 1
              }} transition={{
                duration: 0.7,
                type: "spring",
                bounce: 0.3
              }} className="flex-shrink-0">
                  <img src="/lovable-uploads/056ce10d-4296-4759-990e-af29e752d9e1.png" alt="Company Logo" className="w-12 h-12 object-contain" />
                </motion.div>
                <CardTitle className="text-xl">Company Information</CardTitle>
              </div>
              <CardDescription>&quot;Mr. Designer&quot; A Professional and Expert Company For The Developing of SaaS &amp; App, Webapp Internationally, Certified From International Institutes.</CardDescription>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="flex items-start space-x-3">
                <div className="bg-nalc-teal/10 p-2 rounded-full dark:bg-nalc-teal/20">
                  <MapPin className="h-5 w-5 text-nalc-teal" />
                </div>
                <div>
                  <h3 className="font-medium">Location</h3>
                  <p className="text-sm text-muted-foreground">Kabul, Afghanistan, 1005</p>
                  <Button variant="link" className="p-0 h-auto text-nalc-teal" onClick={openLocation}>
                    View on map
                  </Button>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="bg-nalc-teal/10 p-2 rounded-full dark:bg-nalc-teal/20">
                  <Phone className="h-5 w-5 text-nalc-teal" />
                </div>
                <div>
                  <h3 className="font-medium">Phone</h3>
                  <p className="text-sm text-muted-foreground">+93 784604196</p>
                  <Button variant="link" className="p-0 h-auto text-nalc-teal" onClick={callPhone}>
                    Call us
                  </Button>
                </div>
              </div>

              <div className="flex items-start space-x-3">
                <div className="bg-nalc-teal/10 p-2 rounded-full dark:bg-nalc-teal/20">
                  <Mail className="h-5 w-5 text-nalc-teal" />
                </div>
                <div>
                  <h3 className="font-medium">Email</h3>
                  <p className="text-sm text-muted-foreground">www.mrdesigner.af@gmail.com</p>
                  <Button variant="link" className="p-0 h-auto text-nalc-teal" onClick={sendEmail}>
                    Send an email
                  </Button>
                </div>
              </div>
            </CardContent>
          </Card>

          {/* Developer Information - Using the new DeveloperProfileCard component */}
          <DeveloperProfileCard name="Shukrullah Samadi" role="Mr Designer and Developer" image="/lovable-uploads/b212cf33-bdf0-4794-a4aa-36f777132900.png" contactActions={contactActions} />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} className="mt-8">
          <Card className="bg-white dark:bg-slate-800 shadow-sm">
            <CardHeader>
              <CardTitle className="text-xl">Our Mission</CardTitle>
              <CardDescription>
                Providing quality education and tracking services
              </CardDescription>
            </CardHeader>
            <CardContent>
              <p className="text-muted-foreground">
                At Noor Ali Learning Center, we're dedicated to delivering high-quality educational programs
                and maintaining transparent fee tracking for our students. Our mission is to empower learners
                with accessible education while providing efficient administrative tools for program management.
              </p>
              
              <div className="mt-6 flex gap-4">
                <Link to="/privacy-policy">
                  <Button variant="outline">Privacy Policy</Button>
                </Link>
                <Link to="/terms-conditions">
                  <Button variant="outline">Terms & Conditions</Button>
                </Link>
              </div>
            </CardContent>
          </Card>
        </motion.div>
      </div>
    </div>;
};
export default AboutUs;